<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_2">
<span id="Page_1" title="[1]"></span>
<p class="ph1">Mrs. Harter</p>
<div class="figcenter"><img alt="decoration" class="calibre9" id="id-8322665291294403014" src="OEBPS/Images/2795333090804950542_i009.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section003_split_001.vue?200c7034